import {
  CHEF_SKU_PROMOTION,
  mapMenuPromotion
} from 'src/hooks/useMenuPromotion'
import { ratingTabIndex } from 'src/pages/orders/components/Header/RatingTabButton/RatingTabButton'

export const hydrateMealWithPromotion = meal => {
  const promotionTag = meal.tagsLevel1.find(tag => tag.type === 'PROMOTION')

  if (promotionTag && promotionTag.text?.includes('Save')) {
    const type = promotionTag.text.includes('%') ? 'percent' : 'fixed'
    const value = Number(
      promotionTag.text
        .replace('Save ', '')
        .replace('%', '')
        .replace('$', '')
    )

    return {
      ...meal,
      promotions: [
        {
          type: CHEF_SKU_PROMOTION,
          amount: {
            type,
            value: type === 'percent' ? value / 100 : value
          }
        }
      ]
    }
  }

  return meal
}

export const getMealPromotion = product => {
  if (product.promotions?.length > 0) {
    return mapMenuPromotion(product.promotions[0])
  }

  if (product.cartTags && product.cartTags.length > 0) {
    const hydratedProduct = hydrateMealWithPromotion(product)

    if (hydratedProduct.promotions?.length > 0) {
      return mapMenuPromotion(hydratedProduct.promotions[0])
    }
  }

  return null
}

export const trackSelectedDelivery = (
  track,
  deliveries,
  ratingTab,
  currentTabIndex,
  orderStatusForTracking
) => {
  let trackProps

  if (currentTabIndex !== ratingTabIndex) {
    const selectedDelivery = deliveries[currentTabIndex]
    trackProps = {
      order_status: orderStatusForTracking,
      delivery_date: selectedDelivery?.displayDate,
      shipping_date: selectedDelivery?.date
    }

    if (currentTabIndex === 0) {
      trackProps.order_sequence = 'current'
      trackProps.is_default_tab = 'yes'
    } else if (currentTabIndex > 0) {
      trackProps.order_sequence = `current+${currentTabIndex}`
    }
  } else {
    trackProps = {
      ...ratingTab?.props?.track?.extras,
      shipping_date: undefined,
      is_default_tab: 'no'
    }
  }

  track('Calendar Tab Selected', trackProps)
}

const getMealIdsFromRatingTab = ratingTab => {
  const carrousel = ratingTab?.children.find(
    child => child?.type === 'CARROUSEL'
  )

  if (!carrousel || !Array.isArray(carrousel.children)) {
    return []
  }

  return carrousel.children.map(child => child?.props?.id)
}

export const trackRatingTabSelected = (track, ratingTab) => {
  const mealIds = getMealIdsFromRatingTab(ratingTab)

  track('Rate Tab Selected', {
    ...ratingTab?.props?.track?.extras,
    tab_name: 'rate_order',
    shipping_date: undefined,
    is_default_tab: 'no',
    meal_id_list: mealIds,
    order_id: ratingTab?.props?.orderId,
    tab_rating_status: ratingTab?.props?.hasMealsToRate
      ? 'Rates available'
      : 'No Rates available'
  })
}
